/**
 * Die Werkzeugleiste ueber der Bestellliste - `<div class="order-list-toolbar">` aus `renderBoard`
 * (index.html:7042-7056).
 *
 * ================= Nachtrag 2026-08-13: Titel und Zaehler sind hier ausgezogen =================
 *
 * Der Bestand fuehrte in dieser Leiste zwei `<span>`: `order-list-title` („Bestellboard") und
 * `order-list-count` („12 Bestellungen"). Beide stehen seit dem 2026-08-13 im gemeinsamen
 * Seitenkopf UEBER der Leiste - der Titel als `<h1>`, der Zaehler als Unterzeile. Bewusste
 * Abweichung vom Bestand, siehe Kopfkommentar von `components/App/Seitenkopf.tsx`.
 *
 * Der Zaehlertext samt seiner beiden Bestandseigenheiten (Grundgesamtheit NUR bei gesetzten
 * Spaltenfiltern; Ein- und Mehrzahl an der GEFILTERTEN Zahl, nicht an der Grundgesamtheit) lebt
 * seither in `BoardSeite.tsx`, `zaehlerText()`. Diese Leiste bekommt die beiden Zahlen deshalb
 * nicht mehr - `aktiveSpaltenfilter` bleibt, weil der Knopf „Filter zuruecksetzen" daran haengt.
 *
 * ================= Nachtrag 2026-08-25: „Tracking" aus dem Suchplatzhalter =================
 *
 * Der Bestand beschriftet das Suchfeld „Bestellnummer, Lieferant, Tracking oder Artikel suchen"
 * (index.html:7048). Hier stand vom 2026-08-25 bis zum 2026-09-04 „Bestellnummer, Lieferant oder
 * Artikel suchen" - bewusste Abweichung, in derselben Runde wie die Streichung von
 * `order.trackingNo` aus dem Suchheuhaufen (`BoardSeite.tsx`, Eigenheit 1 - dort die vollstaendige
 * Messung).
 *
 * Grund: `trackingNo` wird im neuen Datenmodell nie mehr befuellt, die Suche kann eine
 * Trackingnummer also gar nicht finden. Ein Platzhalter, der weiterhin dazu einlaedt, ist genau
 * der fehlende Hinweis, den die Streichung beseitigen sollte - er versprach eine Suchbarkeit,
 * die es nicht gibt. Kehrt die Nummer ueber die verknuepfte Sendung zurueck
 * (`sendung.dsvShipmentNo`, Bedingung (a) in `BoardSeite.tsx`), gehoert das Wort wieder hierher.
 *
 * ================= Nachtrag 2026-09-04: Bedingung erfuellt, Platzhalter nachgezogen =============
 *
 * Asana "Suchfunktion erweitern" (1218171668442051) erfuellt genau die oben genannte Bedingung:
 * die Sendungsnummer kommt seither ueber `order.dsvSendungsnummern` zurueck (NICHT ueber
 * `sendung.dsvShipmentNo`/eine aufgeloeste Sendung - siehe Abgrenzung im Nachtrag 2026-09-04 von
 * `BoardSeite.tsx`, Eigenheit 1 - aber dieselbe Suchbarkeit fuer die Nummer selbst). Zusaetzlich
 * treffen seither Rechnungsnummer, PI-Nummer, Bezugsauftrag und Notizen. Der Platzhalter zaehlt
 * bewusst NICHT alle acht Felder auf (zu lang fuer ein Eingabefeld dieser Breite) - "u. a." steht
 * stellvertretend fuer die fuenf nicht genannten. Wer die vollstaendige Liste braucht, findet sie
 * in `BoardSeite.tsx`, Eigenheit 1.
 *
 * ================= Schalter „Neu (n)" (Feature „Neue Artikel markieren und filtern", 2026-11) =================
 *
 * NEUBAU ohne Bestandsvorbild. Der Knopf selbst ist `NeuFilterSchalter` (`components/NeuerArtikelMarke.tsx`),
 * dieselbe Komponente wie im Zeitstrahl: sichtbarer Text `Neu (n)` ist zugleich der zugaengliche Name, der
 * Satz „Nur Bestellungen mit neuen Artikeln zeigen" steht nur im `title` (kein `aria-label`, WCAG 2.5.3).
 * Die Leiste reicht `neu`/`neuAnzahl`/`onNeu` nur durch; Zustand (`Ansicht.board.neu`, `neu=1`), Zaehlung
 * (nach allen uebrigen Filtern) und Filterschritt (Stufe 3a) liegen in `BoardSeite.tsx`.
 *
 * ================= Woertlich uebernommene Eigenheiten =================
 *
 * 3. Die beiden Knoepfe mit der Klasse `order-list-edit-trigger` sehen im Markup gleich aus und
 *    unterscheiden sich nur im Symbol (`settings-2` = Spalteneditor, `columns-3` = Breiten
 *    zuruecksetzen). Beides sind Schreibpfade und gehoeren zu Task 14; die Naht steht hier als
 *    Prop.
 * 4. Der Knopf „Filter zuruecksetzen" erscheint nur bei mindestens einem gesetzten Spaltenfilter
 *    und traegt die Anzahl im Text. Er ist der EINZIGE Knopf der Leiste mit der Klasse
 *    `icon-label`.
 * 5. Der ganze Text steht in EINEM Textknoten je Element - `{n}%`-artige Aufspaltungen (Task 11,
 *    Befund Ü4) sind hier durch Template-Literale ausgeschlossen.
 *
 * ================= Nachtrag 2026-08-11: Rechtesperre am Spalteneditor-Trigger =================
 *
 * Auftraggeber-Entscheidung (Task-3-Brief, Verdrahtungsplan): anders als im Bestand (dort bleibt der
 * Knopf OHNE `manage_settings` bedienbar, die Meldung kommt erst beim Uebernehmen im Dialog,
 * `index.html:7484`) wird der `settings-2`-Ausloeser hier bereits `disabled`, wenn das Recht fehlt -
 * `title`/`aria-label` tragen dann wörtlich "fehlende Berechtigung". `columns-3` (Breiten
 * zuruecksetzen) ist von dieser Sperre NICHT betroffen, siehe Matrixeintrag
 * `test/komponenten/rechte/matrix.test.tsx`.
 *
 * ================= Laenderfilter: umgezogen in die Kopfzeile (2026-08-27) =================
 *
 * Die beiden Umschalt-Chips (🇪🇺/🇨🇳) standen hier bis zum Auftrag „EU/China-Laenderfilter in die
 * App-Kopfzeile verschieben" - NEUBAU ohne Bestandsvorbild, nur im Bestellboard wirksam. Zustand und
 * Bedienung sitzen seither app-weit in `App.tsx`/`components/App/Kopfzeile.tsx` (dort der
 * Kopfkommentar „Vierter Kindknoten"), die Filterlogik selbst in `lib/laender.ts#
 * istBestellungNachLaenderFilterSichtbar` - eine Funktion statt fuenf Kopien, angewandt von allen
 * fuenf bestellungsfuehrenden Seiten. Diese Werkzeugleiste fuehrt seither wieder genau die Elemente,
 * die sie vor diesem Feature hatte.
 *
 * ================= Sammel-Statuswechsel (Auftrag "Auf der Bestellübersicht Sammeländerungen für
 * Status und Bereich", 2026-09-01) =================
 *
 * Neuer Knopf „Status ändern ({N})" - NEUBAU ohne Bestandsvorbild (der Bestand kennt keine
 * Mehrfachauswahl). Sichtbar NUR, solange `ausgewaehlteAnzahl > 0` (dieselbe Bedingtheit wie „Filter
 * zurücksetzen" oben), löst denselben Dialog aus wie der neue Kontextmenue-Eintrag „Status ändern für
 * {N} Bestellungen…" (`KontextMenue.tsx`) - beide Wege sind der Entwurfsentscheidung „Beides
 * anbieten" gefolgt. Klasse `board-batch-button` und Aufbau (Icon + Text) wiederverwendet von
 * „Bestellgruppe" oben - derselbe Bautyp, kein neuer visueller Stil fuer eine einzelne Aktion.
 *
 * Kontotyp "Nur lesen" (`nurLeser`, Neubau): der Sammel-Statuswechsel und das Anlegen einer Bestellgruppe
 * schreiben und werden vom Server fuer ein Konto mit nur `view_*`-Rechten abgelehnt - die Knoepfe „Status
 * ändern ({N})" und „Bestellgruppe anlegen ({N})" entfallen dann (reine Aktionen, deshalb ausgeblendet statt
 * gesperrt). Die Mehrfachauswahl selbst bleibt (Markieren ist Lesen).
 */
import { Ikone } from "../Ikone.tsx";
import { NeuFilterSchalter } from "../NeuerArtikelMarke.tsx";
import { BOARD_STATES, normalisiereBoardStates, type BoardState, type BoardStateSelection } from "../../state/adresse.ts";

/**
 * ================= Auftrag 07 (E2/E3): `<select>` → drei Kontrollkaestchen =================
 *
 * Bis Auftrag 06 stand hier ein `<select>` mit genau drei Werten ("Aktive Bestellungen" / "Aktiv +
 * Archiv" / "Nur Archiv") - ein EINZELWERT. Die Adresse fuehrt aber seit Auftrag 06 eine MENGE
 * (`state=active&state=archived`, `state/adresse.ts`) - der Server liest sie so, und die Spezifikation
 * verlangt ausdruecklich, dass sich jeder Zustand einzeln ein- und ausschalten laesst. Mit einem
 * `<select>` waere "nur aktiv" nicht mehr erreichbar, sobald "archiviert" dazukommt, und ein leeres
 * Ergebnis (kein Kaestchen gesetzt) liesse sich gar nicht ausdruecken.
 *
 * DREI Kaestchen, weil `BOARD_STATES` genau drei Werte kennt - die Beschriftung kommt aus einer
 * eigenen Tabelle, damit ein vierter Zustand an GENAU EINER Stelle nachzutragen waere.
 *
 * DIE LEERE MENGE IST AUSDRUECKLICH ERREICHBAR (beide Richtungen): das letzte gesetzte Kaestchen
 * laesst sich abwaehlen, und die daraus entstehende leere Menge wird als `state=none` geschrieben
 * (`schreibeBoardStates`) - "kein Zustand gewaehlt" heisst "keine Zeile sichtbar", nicht "Vorgabe".
 * Das Protokoll dafuer liegt in `test/komponenten/Board/boardSeite.test.tsx`.
 *
 * `change`, nicht `click`: das Kaestchen ist ein Formularelement mit `checked`-Zustand - `onChange`
 * ist die Form, die auch Tastaturbedienung (Leertaste) traegt. Der Handler gibt die vollstaendige,
 * kanonische Menge ueber `onStates` an `BoardSeite.tsx`.
 *
 * `aria-label` traegt den VORGANG ("… zeigen") und unterscheidet sich bewusst von der sichtbaren
 * Kurzbeschriftung ("Aktiv"): der sichtbare Text bleibt kurz genug fuer die Leiste, waehrend
 * Screenreader und Tests einen eindeutigen, handlungsbeschreibenden Namen bekommen. Beim Kaestchen
 * faellt der sichtbare Text NICHT automatisch als Zugaenglicher Name an, wenn ein `aria-label`
 * gesetzt ist - das Label ist die zusaetzliche, nicht die ersetzende Beschriftung.
 */
const ZUSTANDS_BESCHRIFTUNG: Record<BoardState, { kurz: string; lang: string }> = {
  active: { kurz: "Aktiv", lang: "Aktive Bestellungen zeigen" },
  archived: { kurz: "Archiviert", lang: "Archivierte Bestellungen zeigen" },
  deleted: { kurz: "Gelöscht", lang: "In JTL gelöschte Bestellungen zeigen" },
};

export interface WerkzeugleisteProps {
  /** Zahl der gesetzten Spaltenfilter - traegt allein den Knopf „Filter zuruecksetzen". */
  aktiveSpaltenfilter: number;
  suche: string;
  /** Die gewaehlte Zustandsmenge - kanonisch (`BOARD_STATES`-Reihenfolge), darf LEER sein. */
  states: BoardStateSelection;
  onSuche: (wert: string) => void;
  /** Erhaelt die vollstaendige, kanonische Zustandsmenge nach jedem Toggle. */
  onStates: (states: BoardStateSelection) => void;
  onFilterZuruecksetzen: () => void;
  /**
   * Schalter „Neu (n)": eingeschaltet zeigt das Board nur Bestellungen mit neuen Artikeln
   * (`hatNeueArtikel`, `NeuerArtikelMarke.tsx`). Der Zustand lebt in der Adresse (`Ansicht.board.neu`,
   * `neu=1`), nicht hier. „Filter zurücksetzen" laesst ihn unberuehrt.
   */
  neu: boolean;
  /** Zahl der Bestellungen mit neuen Artikeln NACH allen uebrigen Filtern - traegt allein die Beschriftung. */
  neuAnzahl: number;
  onNeu: (an: boolean) => void;
  /** `openOrderListEditor()`, index.html:7047 - Task 14. */
  onSpaltenEditor?: () => void;
  /** `resetOrderListWidths()`, index.html:7048 - Task 14. */
  onBreitenZuruecksetzen?: () => void;
  /**
   * Ohne `manage_settings`: der Ausloeser bleibt im Baum, wird aber `disabled` und traegt
   * `title="fehlende Berechtigung"` - siehe Kopfkommentar, Nachtrag 2026-08-11. Betrifft
   * ausschliesslich den `settings-2`-Knopf.
   */
  spaltenEditorGesperrt?: boolean;
  /**
   * Groesse der aktuellen Mehrfachauswahl (`ausgewaehlt.size` in `BoardSeite`) - traegt allein den
   * Knopf „Status ändern ({N})", siehe Kopfkommentar.
   */
  ausgewaehlteAnzahl?: number;
  /** Klick auf „Status ändern ({N})" - `BoardSeite` reicht `onSammelStatusAnfordern` durch. */
  onSammelStatus?: () => void;
  /** Leer bei gruppierbarer Auswahl, sonst der Grund fuer den deaktivierten Gruppenknopf. */
  bestellgruppeGesperrt?: string;
  /** Klick auf „Bestellgruppe anlegen ({N})" mit einer gruppierbaren Auswahl. */
  onBestellgruppeAnlegen?: () => void;
  /** Kontotyp "Nur lesen" (`state/nurLeser.ts`): kein Knopf „Status ändern ({N})" und keiner „Bestellgruppe anlegen ({N})". Ohne Angabe: vorhanden. */
  nurLeser?: boolean;
}

/** Schaltet genau einen Zustand um; die leere Auswahl bleibt absichtlich erhalten. */
export function toggleBoardState(states: BoardStateSelection, state: BoardState): BoardStateSelection {
  return normalisiereBoardStates(
    states.includes(state) ? states.filter((value) => value !== state) : [...states, state],
  );
}

export function Werkzeugleiste({
  aktiveSpaltenfilter,
  suche,
  states,
  onSuche,
  onStates,
  onFilterZuruecksetzen,
  neu,
  neuAnzahl,
  onNeu,
  onSpaltenEditor,
  onBreitenZuruecksetzen,
  spaltenEditorGesperrt = false,
  ausgewaehlteAnzahl = 0,
  onSammelStatus,
  bestellgruppeGesperrt,
  onBestellgruppeAnlegen,
  nurLeser = false,
}: WerkzeugleisteProps) {
  return (
    <div className="order-list-toolbar">
      {ausgewaehlteAnzahl > 0 ? (
        <>
          {nurLeser ? null : (
            <button
              className="board-batch-button"
              type="button"
              onClick={() => onSammelStatus?.()}
              title="Status der markierten Bestellungen auf einmal ändern"
            >
              <Ikone name="list-checks" />
              {`Status ändern (${ausgewaehlteAnzahl})`}
            </button>
          )}
          {nurLeser ? null : (
            <button
              className="board-batch-button"
              type="button"
              disabled={!!bestellgruppeGesperrt}
              onClick={() => onBestellgruppeAnlegen?.()}
              title={bestellgruppeGesperrt || "Markierte Bestellungen zu einer Hub-internen Bestellgruppe zusammenfassen"}
            >
              <Ikone name="combine" />
              {`Bestellgruppe anlegen (${ausgewaehlteAnzahl})`}
            </button>
          )}
        </>
      ) : null}
      <button
        className="order-list-edit-trigger"
        type="button"
        onClick={() => onSpaltenEditor?.()}
        disabled={spaltenEditorGesperrt}
        title={spaltenEditorGesperrt ? "fehlende Berechtigung" : "Spalten der Bestellliste anpassen"}
        aria-label="Spalten der Bestellliste anpassen"
      >
        <Ikone name="settings-2" />
      </button>
      <button
        className="order-list-edit-trigger"
        type="button"
        onClick={() => onBreitenZuruecksetzen?.()}
        title="Gespeicherte Spaltenbreiten zurücksetzen"
        aria-label="Gespeicherte Spaltenbreiten zurücksetzen"
      >
        <Ikone name="columns-3" />
      </button>
      <NeuFilterSchalter an={neu} anzahl={neuAnzahl} onUmschalten={onNeu} />
      <input
        id="boardListSearch"
        value={suche}
        placeholder="Bestellnummer, Lieferant, Artikel u. a. suchen"
        onChange={(ereignis) => onSuche(ereignis.target.value)}
      />
      {BOARD_STATES.map((zustand) => (
        <label key={zustand} className="order-list-state-toggle">
          <input
            type="checkbox"
            checked={states.includes(zustand)}
            onChange={() => {
              const neueStates = toggleBoardState(states, zustand);
              onStates(neueStates);
            }}
            aria-label={ZUSTANDS_BESCHRIFTUNG[zustand].lang}
          />
          {ZUSTANDS_BESCHRIFTUNG[zustand].kurz}
        </label>
      ))}
      {aktiveSpaltenfilter ? (
        <button className="order-list-clear-filters icon-label" type="button" onClick={onFilterZuruecksetzen}>
          <Ikone name="filter-x" />
          {`Filter zurücksetzen (${aktiveSpaltenfilter})`}
        </button>
      ) : null}
    </div>
  );
}
